import { faFile, faFileExcel, faFilePdf, faFileVideo, faFileWord, faImage } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import isImage from 'is-image';
import isVideo from 'is-video';

export const FileTypeIcon = ({ color, fileName }: { color?: string; fileName: string }) => {
  const iconProps: Omit<FontAwesomeIconProps, 'icon'> = { color, fontSize: 24 };
  if (isImage(fileName)) return <FontAwesomeIcon icon={faImage} {...iconProps} />;
  if (isVideo(fileName)) return <FontAwesomeIcon icon={faFileVideo} {...iconProps} />;

  const extension = fileName.split('.').pop()?.toLowerCase();
  if (extension === 'pdf') return <FontAwesomeIcon icon={faFilePdf} {...iconProps} />;
  if (extension?.startsWith('doc')) return <FontAwesomeIcon icon={faFileWord} {...iconProps} />;
  if (extension?.startsWith('xl') || extension === 'csv' || extension === 'numbers')
    return <FontAwesomeIcon icon={faFileExcel} {...iconProps} />;

  return <FontAwesomeIcon icon={faFile} {...iconProps} />;
};
